const AUTH_BROADCAST_CHANNEL = 'site-auth-sync';
const LOGOUT_EVENT = 'LOGOUT';

type ClearAuthOptions = {
  broadcast?: boolean;
};

type LogoutMessage = {
  type: typeof LOGOUT_EVENT;
};

let authChannel: BroadcastChannel | null = null;

const getAuthChannel = (): BroadcastChannel | null => {
  if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') {
    return null;
  }

  if (!authChannel) {
    authChannel = new BroadcastChannel(AUTH_BROADCAST_CHANNEL);
  }

  return authChannel;
};

export const clearAuth = (options: ClearAuthOptions = {}): void => {
  const { broadcast = true } = options;

  localStorage.clear();
  sessionStorage.clear();

  if (broadcast) {
    const channel = getAuthChannel();
    channel?.postMessage({ type: LOGOUT_EVENT } as LogoutMessage);
  }

  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

export const setupAuthBroadcastListener = (): (() => void) => {
  const channel = getAuthChannel();

  if (!channel) {
    return () => undefined;
  }

  const onMessage = (event: MessageEvent<LogoutMessage>) => {
    if (event.data?.type === LOGOUT_EVENT) {
      clearAuth({ broadcast: false });
    }
  };

  channel.addEventListener('message', onMessage);

  return () => {
    channel.removeEventListener('message', onMessage);
  };
};
